module.exports = __webpack_public_path__ + "img/Icon-Settings.b5352bd1.svg";